var _rect, _rect2, _rect3, _g, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 89,
    rx: 10,
    fill: "#019371"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 86,
    height: 86,
    rx: 8.5,
    fill: "#019371",
    stroke: "#D7FFC2",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_767_739",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 89
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 88,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_767_739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2193 2.0002C21.4939 63.7261 -3.2298 25.3877 -66.1058 63.9415",
    stroke: "#D7FFC2",
    strokeOpacity: 0.35,
    strokeWidth: 2.2069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.9998 93.6619C25.4361 46.1173 24.6804 95.7636 90.0002 89.2012",
    stroke: "#D7FFC2",
    strokeOpacity: 0.35,
    strokeWidth: 2.2069
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 43,
    height: 42,
    rx: 3.5,
    stroke: "#019371"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 24C25.346 24 24 25.346 24 27V62C24 63.654 25.346 65 27 65H59.3691L62.5 68C64.1 69.6 65.3 68.2 67 66.5C69 64.5 70 64 68.5 62.5L66 60.0371V27C66 25.346 64.654 24 63 24H27ZM33 33H57C57.552 33 58 33.448 58 34C58 34.552 57.552 35 57 35H33C32.448 35 32 34.552 32 34C32 33.448 32.448 33 33 33ZM33 40H57C57.552 40 58 40.448 58 41C58 41.552 57.552 42 57 42H33C32.448 42 32 41.552 32 41C32 40.448 32.448 40 33 40ZM33 47H43C43.552 47 44 47.448 44 48C44 48.552 43.552 49 43 49H33C32.448 49 32 48.552 32 48C32 47.448 32.448 47 33 47ZM49.4414 49.4199L53.4863 50.498L53.6289 50.6406L50.6602 53.543L50.5918 53.4746L49.4414 49.4199ZM55.0488 52.0488L66.7402 63.6582L63.7559 66.6445L52.0742 54.957L55.0488 52.0488Z",
    fill: "#D0FFBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpEditIcon);
export default __webpack_public_path__ + "static/media/lpEdit_icon.f01679c9b6859c19793b8f885a5e79df.svg";
export { ForwardRef as ReactComponent };